/**
 * store/reducers/account/index.js
 *
 * Reducers for the account branch of the state tree.
 *
 * These reducers are delegated to by the root reducer in
 * store/reducers/index.js
 *
 */

/**
 * sets the payload to state.account and clears the data fetching flags
 *
 * @param state
 * @param payload
 * @returns {{account: {isFetching: boolean, didInvalidate: boolean, error: null}}}
 */
export const set = (state, { payload }) => ({
    ...state,
    account: {
        ...payload,
        isFetching:    false,
        didInvalidate: false,
        error: null,
    },
});

/**
 * sets the data fetching flags on state.account to indicate we're loading the account
 *
 * @param state
 * @returns {{account: {isFetching: boolean, didInvalidate: boolean, error: null}}}
 */
export const fetch = (state) => ({
    ...state,
    account: {
        ...state.account,
        isFetching: true,
        didInvalidate: false,
        error: null,
    }
});

/**
 * sets a received account into the store and clears the data fetching flags
 *
 * @param state
 * @param payload
 * @param receivedAt
 * @returns {{account: {lastUpdated: *, isFetching: boolean, didInvalidate: boolean, error: null}}}
 */
export const receive = (state, { payload, receivedAt }) => ({
    ...state,
    account: {
        ...payload,
        isFetching:    false,
        didInvalidate: false,
        error: null,
        lastUpdated: receivedAt,
    },
})

/**
 * sets the data fetching flags on the account to indicate an error.
 *
 * @param state
 * @param payload
 * @returns {{account: {isFetching: boolean, didInvalidate: boolean, error: *}}}
 */
export const fetchError = (state, { payload }) => ({
    ...state,
    account: {
        ...state.account,
        isFetching: false,
        didInvalidate: false,
        error: payload,
    }
});

/**
 * Sets the didInvalidate flag on the current account object.
 * The next fetch action will reload the account.
 *
 * @param state
 * @param payload
 * @returns {{account: {didInvalidate: boolean}}}
 */
export const invalidate = (state, { payload }) => ({
    ...state,
    account: {
        ...state.account,
        didInvalidate: true,
    }
})


export const setPaymentMethod = (state, { payload }) => ({
    ...state,
    account: {
        ...state.account,
        paymentMethod: payload,
    }
})

export const setServices = (state, { payload }) => ({
    ...state,
    account: {
        ...state.account,
        services: payload
    }
})